module.exports = __webpack_public_path__ + "img/Carousel_6.a7dff517.jpg";